import dayjs, { Dayjs } from 'dayjs';

export interface IntervalState {
    from: Dayjs;
    to: Dayjs;
}

export interface Preset {
    label: string;
    days: number;
}

export const PRESETS: Preset[] = [
    { label: '24ч', days: 1 },
    { label: '7д', days: 7 },
    { label: '30д', days: 30 },
    { label: '1г', days: 365 },
];

const DEFAULT_PRESET_IDX = 1; // неделя

export function detectPreset(from: Dayjs, to: Dayjs): number | null {
    const diff = to.startOf('day').diff(from.startOf('day'), 'day');
    const idx = PRESETS.findIndex((p) => p.days === diff + 1);
    return idx >= 0 ? idx : null;
}

export function defaultIntervalState(): IntervalState {
    const now = dayjs();
    return {
        from: now.subtract(PRESETS[DEFAULT_PRESET_IDX].days - 1, 'day').startOf('day'),
        to: now.endOf('day'),
    };
}

export const DATE_PICKER_SLOT_PROPS = {
    textField: {
        size: 'small' as const,
        sx: {
            width: 150,
            '& .MuiInputBase-input': { py: 0.5, px: 1 },
        },
    },
    openPickerButton: { size: 'small' as const, sx: { p: 0.5 } },
};

export const DATE_PICKER_TO_SLOT_PROPS = {
    ...DATE_PICKER_SLOT_PROPS,
    actionBar: { actions: ['today' as const] },
};
